import { IncomeStatementActions } from "./Enums";

export class IncomeStatementFunctions {

    REVENUE: IncomeStatementActions;
    PROFIT: IncomeStatementActions;
    INTEREST: IncomeStatementActions;
    DEPRECIATION: IncomeStatementActions;
    AMORTIZATION: IncomeStatementActions;
    OFFICER_COMP: IncomeStatementActions;
    GUARANTEED_PAYMENTS: IncomeStatementActions;

    static parse(json: any): IncomeStatementFunctions {
        if (json) {
            const isf = new IncomeStatementFunctions();

            isf.REVENUE = IncomeStatementActions[<string>json.REVENUE];
            isf.PROFIT = IncomeStatementActions[<string>json.PROFIT];
            isf.INTEREST = IncomeStatementActions[<string>json.INTEREST];
            isf.DEPRECIATION = IncomeStatementActions[<string>json.DEPRECIATION];
            isf.AMORTIZATION = IncomeStatementActions[<string>json.AMORTIZATION];
            isf.OFFICER_COMP = IncomeStatementActions[<string>json.OFFICER_COMP];
            isf.GUARANTEED_PAYMENTS = IncomeStatementActions[<string>json.GUARANTEED_PAYMENTS];
            
            return isf;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<IncomeStatementFunctions> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(IncomeStatementFunctions.parse(j));

        return arr;
    }
}
